import './pdr-menu-button.css'
import { PdrMenuButtonOptionsElement } from './PdrMenuButtonOptionsElement'
import { PdrMenuButtonOptionElement } from './PdrMenuButtonOptionElement'
import { PdrMenuButtonElement } from './PdrMenuButtonElement'

customElements.define('pdr-menu-button-options', PdrMenuButtonOptionsElement)
customElements.define('pdr-menu-button-option', PdrMenuButtonOptionElement)
customElements.define('pdr-menu-button', PdrMenuButtonElement)
